import { NgModule } from '@angular/core';

// import { LoginModule } from './authentication/login/login.module';
import { Login2Module } from './login-2/login-2.module';
// import { RegisterModule } from './authentication/register/register.module';
// import { Register2Module } from './authentication/register-2/register-2.module';
// import { ForgotPasswordModule } from './authentication/forgot-password/forgot-password.module';
// import { ForgotPassword2Module } from './authentication/forgot-password-2/forgot-password-2.module';
// import { ResetPasswordModule } from './authentication/reset-password/reset-password.module';
// import { ResetPassword2Module } from './authentication/reset-password-2/reset-password-2.module';
// import { LockModule } from './authentication/lock/lock.module';
// import { MailConfirmModule } from './authentication/mail-confirm/mail-confirm.module';
// import { ComingSoonModule } from './coming-soon/coming-soon.module';
// import { Error404Module } from './errors/404/error-404.module';
// import { Error500Module } from './errors/500/error-500.module';
// import { InvoiceCompactModule } from './invoices/compact/compact.module';
// import { InvoiceModernModule } from './invoices/modern/modern.module';
// import { MaintenanceModule } from './maintenance/maintenence.module';
// import { PricingModule } from './pricing/pricing.module';
// import { ProfileModule } from './profile/profile.module';
// import { SearchModule } from './search/search.module';
// import { FaqModule } from './faq/faq.module';
// import { FuseKnowledgeBaseModule } from './knowledge-base/knowledge-base.module';

@NgModule({
    imports: [
        // Auth
        Login2Module

        // Coming-soon
        // ComingSoonModule,

        // // Errors
        // Error404Module,
        // Error500Module,

        // // Invoices
        // InvoiceModernModule,
        // InvoiceCompactModule,

        // // Maintenance
        // MaintenanceModule,

        // // Pricing
        // PricingModule,

        // // Profile
        // ProfileModule,

        // // Search
        // SearchModule,

        // // Faq
        // FaqModule,

        // // Knowledge base
        // FuseKnowledgeBaseModule
    ]
})
export class PagesModule
{
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/pages/pages.module.ts